export { default } from "./ReadAloudSpans";
